module.exports = __webpack_public_path__ + "static/media/finance.41fe80df.svg";